import * as React from 'react';
import ReactDOM from 'react-dom';

import TempControlApp from 'tempcontrol/app';

const tempControlAppRoot = document.getElementById('tempcontrol-app-root');

if (tempControlAppRoot) {
  ReactDOM.render(<TempControlApp />, tempControlAppRoot);
}

if ((module as any).hot) {
  (module as any).hot.accept();
}
